<div *ngIf="showSettingSection">
  <form [formGroup]="form">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12" *ngIf="hasMainTopic">
        <p-message severity="error" text="Main topic not found!"></p-message>
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="name">Name*</label>
        <input
          #projectNameInput
          id="name"
          formControlName="name"
          [class]="invalidField('name') ? 'ng-invalid ng-dirty' : ''"
          pInputText
          maxlength="250"
        />
        <small
          class="block"
          *ngIf="invalidField('name')"
          id="name-help"
          class="p-error"
          >Display Name is a required field.</small
        >
        <div class="shared-control">
          <p-checkbox
            id="shared"
            formControlName="shared"
            [binary]="true"
          ></p-checkbox>
          <label for="shared">Shared with Account?</label>
        </div>
      </div>
      <div class="p-field p-col-12 p-md-6 logo-field">
        <label>Logo</label>
        <app-project-logo
          [projectId]="projectId"
          (imageSelected)="setImageFile($event)"
        ></app-project-logo>
      </div>
      <div class="p-field p-col-6">
      </div>
      <div class="p-field p-col-6">
        <label for="color">Color Scheme</label>
        <div class="color-input-container">
          <input
            #colorInput
            id="color"
            formControlName="color"
            pInputText
            placeholder="Override one or more colors (e.g. #1c2834)"
          />
          <span
            class="color-swatch"
            [style.background-color]="form.get('color').value"
            role="img"
            [attr.aria-label]="'Color preview: ' + (form.get('color').value || 'none')"
          ></span>
        </div>
      </div>
<!--      <div *ngIf="isAdmin()" class="p-field p-col-12">-->
<!--        <label for="name">Description</label>-->
<!--        <a href="https://www.markdownguide.org/basic-syntax/" target="_blank" class="p-ml-3">-->
<!--          <i class="pi pi-question-circle p-mr-1"></i>Markdown Syntax-->
<!--        </a>-->
<!--        <app-markdown-editor-->
<!--          [value]="markdownDescription"-->
<!--          (valueChange)="onMarkdownChange($event)"-->
<!--        ></app-markdown-editor>-->
<!--      </div>-->
      <div *ngIf="isAdmin()" class="p-field p-col-12">
        <label for="name">News Feed Query</label>
        <textarea
          id="query"
          formControlName="query"
          pInputText
          rows="2"
        ></textarea>
      </div>
    </div>
    <div class="project-actions">
      <div class="management-actions">
        <p-button
          icon="pi pi-tags"
          type="button"
          label="Manage Categories"
          class="p-mr-2"
          (click)="openCategoryManager()"
        ></p-button>
        <p-button
          icon="pi pi-envelope"
          type="button"
          label="Manage Alerts"
          (click)="openAlertSettings()"
          pTooltip="Alert Settings"
          tooltipPosition="top"
        ></p-button>
      </div>
      <div class="box-button-right">
        <p-button
          [disabled]="!form.valid || isSaving"
          icon="pi pi-check"
          type="button"
          label="Save"
          class="p-mr-2 save"
          (click)="handleSubmit()"
        ></p-button>
        <p-button
          icon="pi pi-times"
          type="button"
          label="Cancel"
          styleClass="p-button-raised p-button-secondary p-button-text"
          (click)="handleCancel()"
        ></p-button>
      </div>
    </div>
  </form>
</div>
